import { render, staticRenderFns } from "./EditRegistrationPage.vue?vue&type=template&id=6e883082&"
import script from "./EditRegistrationPage.vue?vue&type=script&lang=js&"
export * from "./EditRegistrationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports